const styleOverrides = {
  root: {
    transform: 'translate(14px, 10px) scale(1)',
  },
  shrink: {
    transform: 'translate(14px, -9px) scale(0.75)',
  },
};

export default styleOverrides;
